module.exports = __webpack_public_path__ + "img/Button_RemitPro.da6278a6.png";